import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { REMIND_BOOKING_TO_MERCHANT } from 'actions/leads/types'
import clsx from 'clsx'
import Bell from '../../../shared/icons/bell'

const TopInquiry = ({
  date,
  status,
  address,
  name,
  isAdmin,
  conversationId,
  remindBookingToMerchant,
  leadDetail,
}) => {
  const [isOpenPopupRemind, setIsOpenPopupRemind] = useState(false)
  const now = moment().utc()
  const duration = now.diff(leadDetail?.remind_time)
  const isActiveRemind = duration ? duration > 24 * 60 * 60 * 1000 : true

  useEffect(() => {
    setIsOpenPopupRemind(false);
  }, [conversationId])

  const statusStyleMap = {
    expired: 'text-green-400 bg-green-200',
    pending: 'text-orange-400 bg-orange-150',
    'cancelled by client': 'text-red-600 bg-red-200',
    accepted: 'text-green-400 bg-green-200',
    'declined by space': 'text-red-600 bg-red-200',
    'proposal sent': 'text-green-400 bg-green-200',
    'cancelled by space': 'text-red-600 bg-red-200',
    'pending payment': 'text-orange-400 bg-orange-150',
    paid: 'text-green-400 bg-green-200',
  }
  return (
    <div className="top-inquiry bg-gray-200 md:flex hidden justify-between items-center p-2 pb-2 relative">
      <div>
        <span
          className={clsx(
            'text-center top-inquiry-status mr-2 lg:px-4 py-1 rounded text-xs font-bold',
            statusStyleMap[status]
          )}
        >
          {status && status.toUpperCase()}
        </span>
        {status === 'pending' && (
          <>
            <span
              className='cursor-pointer'
              onClick={() => isActiveRemind && setIsOpenPopupRemind((prev) => !prev)}
            >
              <Bell color={clsx(isActiveRemind ? '#EBB164' : '#C1C1C1')} />
            </span>
            <div
              className={clsx(
                'bg-orange-100 px-8 py-10 absolute popup-remind',
                isOpenPopupRemind || 'hidden'
              )}
            >
              <h3 className="font-bold leading-tight text-lg mb-2">Remind the Space Operator?</h3>
              <p className="font-normal text-xs leading-4 mb-6">
                The prompt will be directed to the Space Operators.
                <br />
                You can resend the reminder after 24 hours if the request is still not accepted
              </p>
              <div className="flex justify-between">
                <button
                  type="button"
                  className="text-orange-400 border"
                  onClick={() => setIsOpenPopupRemind(false)}
                >
                  No
                </button>
                <button
                  type="button"
                  className="text-white bg-orange-400"
                  onClick={async () => {
                    await remindBookingToMerchant({ conversationId })
                    setIsOpenPopupRemind(false)
                  }}
                >
                  Send the reminder
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="text-center">
        <div className="font-bold md:text-base text-xs text-black">
          {isAdmin ? 'FlySpaces Space Expert' : name}
        </div>
        <div className="text-xs">{address !== 'undefined' ? address : ''}</div>
        {isAdmin && (
          <div className="text-xs">
            Send us a message and space expert will get back to you shortly!
          </div>
        )}
      </div>
      <div className={clsx('top-inquiry-date md:text-right text-center', isAdmin && 'invisible')}>
        <div className="font-semibold text-xs text-gray-600">{date ? 'LEAD CREATED ON' : ''}</div>
        <div className="text-xs font-medium text-gray-800">
          {date ? moment(date).format('MMMM DD, YYYY') : ''}
        </div>
      </div>
    </div>
  )
}

TopInquiry.propTypes = {
  date: PropTypes.string,
  status: PropTypes.string,
  address: PropTypes.string,
  name: PropTypes.string,
  isAdmin: PropTypes.bool,
  conversationId: PropTypes.number,
  remindBookingToMerchant: PropTypes.func,
  leadDetail: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => ({
  remindBookingToMerchant: (payload) => dispatch({ type: REMIND_BOOKING_TO_MERCHANT, payload }),
})

export default connect(null, mapDispatchToProps)(TopInquiry)
